<template>
  <b-dropdown
    position="is-bottom-left"
    append-to-body
    aria-role="menu"
    class="custom-notification-button"
  >
    <template #trigger>
      <button
        v-if="currentLanguage"
        style="background-color: transparent; border: none"
      >
        <img class="icon-flag" :src="icon(currentLanguage)" alt="" />
      </button>
    </template>
    <div>
      <b-dropdown-item
        v-for="language in languages"
        :key="language.id"
        class="drop-item-language"
        :class="isSelected(language) ? 'selected' : ''"
      >
        <b-navbar-item tag="a" class="py-1" @click.native="goTo(language)">
          <img class="icon-flag" :src="icon(language.language_code)" alt="" />
          <span class="ml-3">{{ language.language_name }}</span>
        </b-navbar-item>
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import IconBell from "@/components/icons/IconBell.vue";
import { mapGetters } from "vuex";

export default {
  name: "NavbarItemLanguage",
  components: { IconBell },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      languages: "language/getLanguages",
      currentLanguage: "language/getCurrentLanguage",
    }),
  },
  watch: {
    itinerary: {
      immediate: true,
      handler() {
        const params = new URLSearchParams(window.location.search);
        if (!params.get("lang") && this.itinerary.data) {
          const lang = this.itinerary.data.language.language_code;
          this.$store.dispatch("language/setCurrentLanguage", lang);
        }
      },
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get("lang") ?? "EN";
    this.$store.dispatch("language/getLanguages");
    this.$store.dispatch("language/setCurrentLanguage", lang);
  },
  methods: {
    isSelected(language) {
      return this.currentLanguage === language.language_code;
    },
    icon(language) {
      return `/img/lang/${language.toLowerCase()}.webp`;
    },
    async goTo(language) {
      const url = new URL(window.location.href);
      url.searchParams.set("lang", language.language_code);
      window.location.href = url.toString();
    },
  },
};
</script>

<style scoped>
.icon-flag {
  width: 30px;
}

.drop-item-language.selected,
.drop-item-language.selected:hover {
  background-color: rgb(243, 208, 208);

  .navbar-item {
    background-color: inherit !important;
  }
}
</style>
